"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Services() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="17" id="chillwatersolutions" className="bg-background text-foreground py-24 md:py-32 lg:py-40 px-4 sm:px-6 lg:px-8 border-b border-border">
      <div className="max-w-4xl mx-auto">
        <div ref={headerRef} className={`transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-default text-sm font-bold uppercase tracking-[0.2em] mb-6 text-primary">
            Our Solutions
          </p>
          <h2 className="font-default font-bold text-4xl sm:text-5xl md:text-6xl leading-[1.05] text-foreground mb-10">
            Our Chill Water Pump & <br className="hidden md:block" />
            <span className="text-primary">Cooling Tower Solutions</span>
          </h2>
          
          <div className="pl-6 border-l-4 border-accent">
            <p className="font-sans text-xl md:text-2xl font-light text-muted-foreground leading-relaxed">
              AA Eagle Plumbing handles cooling tower maintenance, repair, and installation across the Miami metro area.
            </p>
          </div>
        </div>
      </div>
    </section>;
}